import { FormBase } from 'core/components';

export default class BackOrderEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'backOrderNote',
                    label: 'PICK_TICKET_DETAIL.EDIT_BACK_ORDER.BACK_ORDER_NOTE_LABEL',
                    placeholder: 'PICK_TICKET_DETAIL.EDIT_BACK_ORDER.BACK_ORDER_NOTE_PLACEHOLDER',
                },
                {
                    name: "backOrder",
                    type: "bool",
                    rules: 'required'                
                },
            ],
        };
    }
}
